import { render, staticRenderFns } from "./SuccessStories.vue?vue&type=template&id=21f55c2c&"
import script from "./SuccessStories.vue?vue&type=script&lang=js&"
export * from "./SuccessStories.vue?vue&type=script&lang=js&"
import style0 from "./SuccessStories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports